import { checkIfRDQSTSignal } from './dataProcess';
import { portSavePath } from "../constants";

function componentPinsModelCheck(components) {
  if (!components) {
    return false;
  }
  let ifSetModel = true;
  components.forEach(component => {
    const type = component.type === "Controller" ? "driver" : component.type === "Memory" ? "receiver" : "";
    if (!type) {
      return;
    }
    component.pins.forEach(pin => {
      const keys = Object.keys(pin);
      if (keys.includes('driver') && pin['driver'].model && Object.keys(pin['driver'].model).length === 0) {
        ifSetModel = checkIfRDQSTSignal(pin.signal) && type === 'driver';
      }
      if (keys.includes('receiver') && pin['receiver'].model && Object.keys(pin['receiver'].model).length === 0) {
        ifSetModel = checkIfRDQSTSignal(pin.signal) && type === 'receiver';
      }

    })
  });
  return ifSetModel;
}

function getInterfacePackageLayoutId(Interfaces) {
  let packageLayoutId = null, packageLayoutInfo = {}, isMultiRank = false;
  if (Interfaces && Interfaces.length) {
    const interfaceIndex = Interfaces.findIndex(i => portSavePath.find(p => i.name.match(p))) || 0;
    const findControllerComp = Interfaces[interfaceIndex].Content.Components.find(item => item.type === 'Controller')
    if (findControllerComp && findControllerComp.pkg && findControllerComp.pkg.type === 'Layout' && findControllerComp.pkg.packageLayoutInfo
      && findControllerComp.pkg.packageLayoutInfo.packageId && findControllerComp.pkg.packageLayoutInfo.channelId) {
      packageLayoutId = findControllerComp.pkg.packageLayoutInfo.packageId;
      packageLayoutInfo = { ...findControllerComp.pkg.packageLayoutInfo }
    }

    const findMemoryComps = Interfaces[interfaceIndex].Content.Components.filter(item => item.type === 'Memory')
    if (findMemoryComps && findMemoryComps.length) {
      isMultiRank = findMemoryComps.find(item => item.pkg && item.pkg.rank)
    }

  }
  return { packageLayoutId, packageLayoutInfo, isMultiRank };
}

function parseBallMapCSV(csvContent) {
  const lines = csvContent.split('\n');
  const result = [];

  if (lines.length === 0) {
    return result;
  }

  // Check if the first line contains "SIGNAL NAME" or "PIN NUMBER"
  const firstLine = lines[0].trim();
  let pinNumberIndex = 1; // Default: second column is PIN NUMBER
  let signalNameIndex = 0; // Default: first column is SIGNAL NAME
  let startRow = 0; // Default: start parsing data from row 1

  // Check if the first line contains header keywords
  if (firstLine) {
    const firstLineUpper = firstLine.toUpperCase();

    // Check if it contains "SIGNAL NAME" or "PIN NUMBER"
    const isHeader = firstLineUpper.includes('SIGNAL NAME') ||
      firstLineUpper.includes('SIGNAL_NAME') ||
      firstLineUpper.includes('PIN NUMBER') ||
      firstLineUpper.includes('PIN_NUMBER');

    if (isHeader) {
      // It's a header row, determine column indices
      const headers = parseCSVLine(firstLine);
      pinNumberIndex = -1;
      signalNameIndex = -1;

      for (let i = 0; i < headers.length; i++) {
        const header = headers[i].toUpperCase();

        if (header.includes('PIN')) {
          pinNumberIndex = i;
        } else if (header.includes('SIGNAL')) {
          signalNameIndex = i;
        }
      }

      // Ensure both columns are found, otherwise use default values
      if (pinNumberIndex === -1 || signalNameIndex === -1) {
        // If one is found but not the other, try positional logic
        if (pinNumberIndex === -1 && signalNameIndex !== -1) {
          // SIGNAL found, PIN uses the other position
          pinNumberIndex = (signalNameIndex === 0) ? 1 : 0;
        } else if (signalNameIndex === -1 && pinNumberIndex !== -1) {
          // PIN found, SIGNAL uses the other position
          signalNameIndex = (pinNumberIndex === 0) ? 1 : 0;
        } else {
          // Neither found, use default values
          signalNameIndex = 0;
          pinNumberIndex = 1;
        }
      }

      startRow = 1; // Has header, start parsing data from row 2
    } else {
      // Not a header, use default values
      signalNameIndex = 0;
      pinNumberIndex = 1;
      startRow = 0; // Start parsing data from row 1
    }
  }

  // Parse data rows
  for (let i = startRow; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) {
      continue; // Skip empty lines
    }

    try {
      const cells = parseCSVLine(line);

      // Ensure there are enough columns
      if (cells.length > Math.max(pinNumberIndex, signalNameIndex)) {
        const pinNumber = cells[pinNumberIndex];
        const signalName = cells[signalNameIndex];

        // Check if it's valid data (non-empty)
        if (pinNumber && signalName) {
          result.push({
            pinNumber: pinNumber.trim(),
            signalName: signalName.trim()
          });
        }
      }
    } catch (error) {
      console.warn(`Error parsing line ${i + 1}:`, error);
      // Continue processing other lines
    }
  }

  return result;
}

// Helper function: Parse CSV line, handle quotes and commas
function parseCSVLine(line) {
  const cells = [];
  let inQuotes = false;
  let currentCell = '';

  for (let j = 0; j < line.length; j++) {
    const char = line[j];

    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === ',' && !inQuotes) {
      cells.push(currentCell);
      currentCell = '';
    } else {
      currentCell += char;
    }
  }

  // Add the last cell
  cells.push(currentCell);

  return cells;
}

function findBestMatchingComponent(componentMap, pins) {
  if (!pins || pins.length === 0) {
    return {
      component: null,
      count: 0,
      allMatches: {}
    };
  }

  const allMatches = {};
  let bestComponent = null;
  let bestCount = 0;
  for (const [componentName, componentPins] of componentMap.entries()) {
    const matchedCount = pins.filter(pin => componentPins.includes(pin)).length;
    if (matchedCount > 0) {
      allMatches[componentName] = matchedCount;
      if (matchedCount > bestCount) {
        bestCount = matchedCount;
        bestComponent = componentName;
      }
    }
  }

  return {
    component: bestComponent,
    count: bestCount,
    allMatches: allMatches
  };
}

export { componentPinsModelCheck, getInterfacePackageLayoutId, parseBallMapCSV, findBestMatchingComponent };